import {ProductApi} from "@core/api";
import Vue from 'vue'
import {fromCard} from "@core/domain/product/factory";
import {RequestStatus} from "@/libs/product";
import store from "@/store"

let organizationId = store.state.user.organization.id;
let requests = {};
requests[organizationId] = {};

store.watch(
    (state) => {
        return state.user.organization;
    },
    () => {
        organizationId = store.state.user.organization.id;
        if (!requests.hasOwnProperty(organizationId)) {
            requests[organizationId] = {};
        }
    }
)

export const DeclarationApprovalMethod = {
    PHONE: 'phone',
    EMAIL: 'email',
};

export function receivedRequestProvider(id) {
    if (requests[organizationId][id]) {
        return requests[organizationId][id];
    }

    return requests[organizationId][id] = new ReceivedRequest(id);
}

export function clearCachedReceivedRequest(id) {
    if (requests[organizationId][id]) {
        delete requests[organizationId][id];
    }
}

export class ReceivedRequest {
    id;
    request;
    product;
    requestPromise;

    constructor(id) {
        this.id = id;
    }

    getRequest() {
        if (this.requestPromise) {
            return this.requestPromise;
        }
        return this.requestPromise = new Promise((resolve, reject) => {
            ProductApi
                .getCustomerRequest(this.id)
                .then(r => {
                    this.request = Vue.observable(r.data);
                    this.product = fromCard(this.request.product);
                    resolve(this);
                })
                .catch(reject)
            ;
        });
    }

    getProduct() {
        return this
            .getRequest()
            .then(() => {
                this.product = fromCard(this.request.product);
                return this.product;
            });
    }

    setInformationOwner(informationOwner) {
        this.request.informationOwner = informationOwner;
    }

    setIsComplex(isComplex) {
        this.request.isComplexProduct = isComplex;
    }

    setOtherInformation(otherInformation) {
        this.request.otherInformation = otherInformation;
    }

    setGuaranteedWeightPercentageConfirmed(value) {
        this.request.guaranteedWeightPercentageConfirmed = Boolean(value);
    }

    getForwardedRequests() {
        return ProductApi.getForwardedRequests(this.id);
    }

    getBulkReplyCandidates() {
        return ProductApi.getBulkReplyCandidates(this.id);
    }

    markStepAsUnDone(step) {
        if (this.request.doneSteps && this.request.doneSteps.includes(step)) {
            this.request.doneSteps.splice(
                this.request.doneSteps.findIndex(s => s === step),
                1
            );
        }
    }

    isStepDone(step) {
        return this.request.doneSteps && this.request.doneSteps.includes(step);
    }

    markStepAsDone(step) {
        if (!this.request.doneSteps) {
            this.request.doneSteps = [];
        }
        if (!this.isStepDone(step)) {
            this.request.doneSteps.push(step);
        }
    }

    reply(declaration) {
        return ProductApi
            .replyToRequest(this.id, declaration)
            .then(() => {
                this.request.status = RequestStatus.REPLIED;
                this.$swal({
                    title: 'Good job!',
                    text: 'Declaration has been sent to a customer!',
                    icon: 'success',
                    timer: 1000,
                    allowOutsideClick: true,
                    customClass: {
                        confirmButton: 'btn btn-primary',
                    },
                    buttonsStyling: false,
                });
            })
    }

    save() {
        return ProductApi.updateCustomerRequest(this.id, {
            informationOwner: this.request.informationOwner,
            isComplexProduct: this.request.isComplexProduct,
            guaranteedWeightPercentageConfirmed: Boolean(this.request.guaranteedWeightPercentageConfirmed),
            otherInformation: this.gatherOtherInformation(),
            doneSteps: this.request.doneSteps || []
        });
    }

    refreshSubstanceState() {
        return ProductApi
            .getSubstanceState(
                this.product.id,
                this.request.legislations.map(l => l.id)
            )
            .then(r => {
                this.request.substanceState = r.data;
                return r.data;
            });
    }

    gatherOtherInformation() {
        let declarationValidity = this.request.otherInformation ? this.request.otherInformation.declarationValidity : null;
        if (declarationValidity && typeof declarationValidity === 'object') {
            declarationValidity = declarationValidity.month;
        }

        return {
            internalComment: this.request.otherInformation ? this.request.otherInformation.internalComment : null,
            customerInformation: this.request.otherInformation ? this.request.otherInformation.customerInformation : null,
            declarationValidity: declarationValidity
        };
    }
}
